<template>
  <section id="goals" class="goals">
    <h2>Choose What Fits Your Goals</h2>

    <div class="cards">
      <div
        class="card"
        @click="$router.push({ path: '/we-circular/national-strategies', query: { country: countryName } })"
      >
        <div class="card__top">
          <div class="icon-box">
            <svg viewBox="0 0 24 24" fill="white" width="32" height="32">
              <path
                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
              />
            </svg>
          </div>
        </div>
        <div class="card__bottom">
          <h3>National Strategies</h3>
          <p>
            Discover the national strategies and country specific analysis related to Circular Economy, Digitalization,
            Women Entrepreneurs, and Smart Specialisation Strategies (S3). Explore each topic below and dive deeper into
            the most relevant documents.
          </p>
        </div>
      </div>

      <div
        class="card"
        @click="$router.push({ path: '/we-circular/policy-instruments', query: { country: countryName } })"
      >
        <div class="card__top">
          <div class="icon-box">
            <svg viewBox="0 0 24 24" fill="white" width="32" height="32">
              <path
                d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.5 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"
              />
            </svg>
          </div>
        </div>
        <div class="card__bottom">
          <h3>Policy instruments and incentives</h3>
          <p>
            This section provides an overview of key national policy tools and incentive mechanisms supporting women-led
            enterprises, the circular economy, Industry 4.0 adoption, and smart specialisation objectives.
          </p>
        </div>
      </div>

      <div class="card" :class="{ 'card--disabled': !regionalActionPlanUrl }" @click="openRegionalActionPlan">
        <div class="card__top">
          <div class="icon-box">
            <svg viewBox="0 0 24 24" fill="white" width="32" height="32">
              <path
                d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.1-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.45-.75-2.25-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-3.45.3-5 1V7c1.55-.7 3.3-.1 5 1 1.2.35 2.3.5 3.5.5v10.5z"
              />
            </svg>
          </div>
        </div>
        <div class="card__bottom">
          <h3>Regional Action Plan</h3>
          <p>
            The Regional Action Plans translate the regions’, countries’ WE.Circular project’s related strategic
            objectives into concrete, region-specific actions, addressing key challenges and opportunities related to
            women-led enterprises, digitalisation, the circular economy and Smart Specialisation strategies.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const regionalActionPlanDocuments = {
  Austria: 'O_3_1_Regional_Action_Plan_Austria.pdf',
  'Bosnia and Herzegovina': 'O_3_1_Regional_Action_Plan_Bosnia_and_Herzegovina.pdf',
  Bulgaria: 'O_3_1_Regional_Action_Plan_Bulgaria.pdf',
  Germany: 'O_3_1_Regional_Action_Plan_BW_Germany.pdf',
  Croatia: 'O_3_1_Regional_Action_Plan_Croatia.pdf',
  Czechia: 'O_3_1_Regional_Action_Plan_Czech_Republic.pdf',
  Hungary: 'O_3_1_Regional_Action_Plan_Hungary.pdf',
  Moldova: 'O_3_1_Regional_Action_Plan_Moldova.pdf',
  Romania: 'O_3_1_Regional_Action_Plan_Romania.pdf',
  Serbia: 'O_3_1_Regional_Action_Plan_Serbia.pdf',
  'Slovak Republic': 'O_3_1_Regional_Action_Plan_Slovakia.pdf',
  Slovenia: 'O_3_1_Regional_Action_Plan_Slovenia.pdf'
}

export default {
  props: {
    countryName: {
      type: String,
      default: 'this country'
    }
  },
  computed: {
    regionalActionPlanUrl() {
      const fileName = regionalActionPlanDocuments[this.countryName]

      return fileName ? `https://vali.hu/static/${fileName}` : null
    }
  },
  methods: {
    openRegionalActionPlan() {
      if (!this.regionalActionPlanUrl) {
        return
      }

      window.open(this.regionalActionPlanUrl, '_blank', 'noopener,noreferrer')
    }
  }
}
</script>

<style scoped>
.goals {
  padding: 100px 80px;
  background: #ffffff;
}

h2 {
  text-align: center;
  font-size: 48px;
  color: #003399; /* javítva */
  margin-bottom: 60px;
  font-weight: 800;
}

.cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
}

.card {
  border-radius: 24px;
  overflow: hidden;
  border: 2px solid #18baa8; /* javítva */
  display: flex;
  flex-direction: column;
  height: 100%;
}

.card__top {
  background: #18baa8; /* javítva */
  height: 100px;
  position: relative;
  display: flex;
  justify-content: center;
}

.icon-box {
  width: 64px;
  height: 64px;
  background: #004444; /* javítva */
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: -32px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.card__bottom {
  background: #ffffff;
  padding: 60px 30px 25px;
  flex-grow: 1;
  text-align: center;
}

h3 {
  font-size: 24px;
  color: #003399; /* javítva */
  margin-bottom: 20px;
  font-weight: 700;
}

p {
  font-size: 16px;
  line-height: 1.6;
  color: #0e6eb6; /* javítva */
}

@media (max-width: 1100px) {
  .cards {
    grid-template-columns: 1fr;
    max-width: 500px;
  }
}
</style>
